import React, {Component} from "react"
import PropTypes from "prop-types";


export class CommandsProvider extends Component {

  getChildContext() {
    return { commands: this.props.commands }
  }
  render() {
    // `Children.only` enables us not to add a <div /> for nothing
    return React.Children.only(this.props.children)
  }
}


CommandsProvider.propTypes = {
  commands: PropTypes.object.isRequired
}
// you must specify what you’re adding to the context
CommandsProvider.childContextTypes = {
  commands: PropTypes.object.isRequired
}

export const withCommands = (ComponentToWrap) => {
  class CommandsComponent extends Component {
    render() {
      return (
        <ComponentToWrap {...this.props} commands={this.context.commands} />
      )
    }
  }
  CommandsComponent.contextTypes = {
    commands: PropTypes.object.isRequired,
  }
  return CommandsComponent
}
